(function (w, d) {
  'use strict';

  var boot = d.getElementById('es-header-runtime');
  if (!boot || boot.getAttribute('data-es-booted') === '1') return;
  boot.setAttribute('data-es-booted', '1');

  try {
    var src = boot.getAttribute('data-search-enhance-src') || '';
    if (!src) return;

    var isSearchPage = boot.getAttribute('data-search-page') === '1';
    var loaded = false;
    var loading = false;
    var waitingForJq = false;
    var searchPageRetries = 0;
    var intentSelector = '.js-search-destop, .search-full-destop, .search-full-destop .js_engo_autocomplate';
    var events = ['pointerover', 'touchstart', 'focusin', 'click'];

    function disarmIntent() {
      for (var i = 0; i < events.length; i++) {
        d.removeEventListener(events[i], onIntent, true);
      }
    }

    function finishLoaded(script) {
      loading = false;
      loaded = true;
      if (script) script.setAttribute('data-es-loaded', '1');
      if (!isSearchPage) disarmIntent();
    }

    function failLoaded(script) {
      loading = false;
      loaded = false;
      if (script) {
        script.setAttribute('data-es-load-failed', '1');
        try { script.remove(); } catch (_err) {}
      }
      if (isSearchPage && searchPageRetries < 1) {
        searchPageRetries += 1;
        w.setTimeout(load, 1200);
      }
    }

    function append() {
      waitingForJq = false;
      if (loaded || loading) return;

      var existing = d.querySelector('script[data-es-search-enhance-asset]');
      if (existing && existing.getAttribute('data-es-load-failed') === '1') {
        try { existing.remove(); } catch (_err) {}
        existing = null;
      }
      loading = true;
      var loader = w.ES && w.ES.loader;
      if (loader && typeof loader.script === 'function') {
        loader.script('header:search-enhance', src, {
          async: true,
          reject: true,
          selector: 'script[data-es-search-enhance-asset]',
          attributes: { 'data-es-search-enhance-asset': 'es-search-enhance.js' }
        }).then(finishLoaded).catch(function () { failLoaded(null); });
        return;
      }

      // Keep search recoverable even if the shared runtime is unavailable.
      var script = existing || d.createElement('script');
      if (script.getAttribute('data-es-loaded') === '1') { finishLoaded(script); return; }
      var settled = false;
      var timer;
      function finish(success) {
        if (settled) return;
        settled = true;
        w.clearTimeout(timer);
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
        if (success) finishLoaded(script); else failLoaded(script);
      }
      function onLoad() { finish(true); }
      function onError() { finish(false); }
      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', onError, { once: true });
      timer = w.setTimeout(onError, 15000);
      if (!existing) {
        script.src = src;
        script.async = true;
        script.setAttribute('data-es-search-enhance-asset', 'es-search-enhance.js');
        try { (d.head || d.documentElement).appendChild(script); }
        catch (_appendSearchError) { onError(); }
      }
    }

    function load() {
      if (loaded || loading) return;
      if (!w.jQuery) {
        if (!waitingForJq) {
          waitingForJq = true;
          d.addEventListener('es:jQueryReady', append, { once: true });
          w.setTimeout(function () {
            if (w.jQuery) append();
          }, 1600);
        }
        return;
      }
      append();
    }

    function onIntent(event) {
      var target = event && event.target;
      if (!target || !target.closest || !target.closest(intentSelector)) return;
      load();
    }

    if (isSearchPage) {
      if (w.ES_jqReady) w.ES_jqReady(load);
      else load();
      return;
    }

    for (var i = 0; i < events.length; i++) {
      d.addEventListener(events[i], onIntent, true);
    }
  } catch (_err) {}
})(window, document);
